<template>
  <div>
    <b-modal
      ref="audioOutputs"
      centered
      hide-header
      hide-footer
      hide-header-close
      body-class="audio-outputs-body p-0 text-dark"
      content-class="audio-outputs-modal"
      data-test-id="audio-outputs-modal"
    >
      <div class="p-1 pl-3 mt-2 text-left audio-outputs__title">Select Device for audio output</div>

      <b-list-group class="w-100">
        <b-list-group-item
          v-for="item in audioOutputs"
          :key="item.id"
          class="audio-outputs__item pl-3 border-top-0 border-left-0 border-right-0 border-bottom"
          data-test-id="audio-outputs-item"
          @click="setAudioOutput(item.id)"
        >
          <h5 class="d-block text-left font-weight-bold">{{ item.name }}</h5>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

const REF_NAME = "audioOutputs";

export default {
  name: "AudioOutputs",
  computed: {
    ...mapState("Voip", ["audioOutputs"]),
  },
  methods: {
    ...mapActions("Voip", ["setAudioOutputDevice"]),
    setAudioOutput(deviceId) {
      this.setAudioOutputDevice(deviceId);
      this.hide();
    },
    show() {
      this.$refs[REF_NAME].show();
    },
    hide() {
      this.$refs[REF_NAME].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.audio-outputs-body {
  background-color: #fff;
  border: 1px solid #cbcbcb;
  border-radius: 10px;
}

.audio-outputs-modal {
  border-radius: 10px;
  color: #575757;
}

.audio-outputs__title {
  background: #eeeeee;
}

.text-dark {
  color: #575757;
}

.font-bigger {
  font-size: 1.2em;
}

.audio-outputs__item:active,
.audio-outputs__item:hover {
  background-color: #dddddd;
  fill-opacity: 0.8;
}
</style>
